import { Button, Divider, Form } from "antd";
import { FormattedMessage } from "react-intl";
import Tabs from "components/layout/Tabs";

import { TicketTemplateFormProps, TicketTemplateFormValues } from "./types";
import { ticketTemplateFormLayout } from "./consts";
import { useTicketTemplateFormTabs } from "./hooks";

const TicketTemplateForm: React.FC<TicketTemplateFormProps> = ({
  loading,
  ...props
}) => {
  const tabs = useTicketTemplateFormTabs();

  return (
    <Form<TicketTemplateFormValues> {...ticketTemplateFormLayout} {...props}>
      <Tabs items={tabs} />
      <Divider />
      <Form.Item>
        <Button type="primary" htmlType="submit" {...{ loading }}>
          <FormattedMessage defaultMessage="Submit" />
        </Button>
      </Form.Item>
    </Form>
  );
};

export default TicketTemplateForm;
